import { useDispatch, useSelector } from "react-redux"
import { ToastContainer, toast } from "react-toastify"
import { bodySelector, setBody, setToastId, setType, toastIdSelector, typeSelector } from "./services/NotificationSlice"
import { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";

const Notifications = () => {

    const dispatch = useDispatch();
    const body = useSelector(bodySelector);
    const type = useSelector(typeSelector);
    const toastId = useSelector(toastIdSelector);

    useEffect(() => {
        if(type && body){
            switch(type) {
                case 'error':
                    toast.error(body, {
                        autoClose: 2000,
                        hideProgressBar: true,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
                    break;
                case 'info':
                    toast.info(body, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                        isLoading: true,
                        toastId: toastId
                    })
                    break;
                // Stays until it is dismissed. A chip being taken off the
                // board is the one event a player must not miss on a timer.
                // On a phone it would cover the top of the board for the whole
                // turn, so it goes after a while; the dashed ring it left on
                // the board still marks the space.
                case 'sticky':
                    toast.warning(body, {
                        autoClose: document.documentElement.classList.contains('phone-play') ? 6000 : false,
                        closeOnClick: true,
                        hideProgressBar: true,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
                    break;
                case 'dismiss':
                    toast.dismiss(toastId);
                    break;
                case 'warning':
                    toast.warning(body, {
                        autoClose: 4500,
                        hideProgressBar: true,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
                    break;
                case 'success':
                    toast.success(body, {
                        autoClose: 2000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
                    break;
                default:
                    toast.error(body, {
                        autoClose: 2000,
                        hideProgressBar: true,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        toastId: toastId
                    })
            }
            if(body !== ''){
                dispatch(setBody(''));
                dispatch(setType(''));
                dispatch(setToastId(''));
            }
        }

    }, [body, type, toastId, dispatch])

    return(
        <> 
            <ToastContainer />
        </>
    )
}

export default Notifications;